/* Copyright (C) 2009 - 2025 Coozila! */
/* exported AutoComplete */

(function (w, d, coozila) {
  'use strict';

  var qinput_id = "q", qinput;

  const isMobile = window.matchMedia("only screen and (max-width: 50em)").matches;
  const isResultsPage = document.querySelector("main").id == "main_results";

  function submitIfQuery () {
    if (qinput.value.length  > 0) {
      var search = document.getElementById('search');
      setTimeout(search.submit.bind(search), 0);
    }
  }

  function createClearButton (qinput) {
    var cs = document.getElementById('clear_search');
    var updateClearButton = function () {
      if (qinput.value.length === 0) {
        cs.classList.add("empty");
      } else {
        cs.classList.remove("empty");
      }
    };

    // update status, event listener
    updateClearButton();
    cs.addEventListener('click', function (ev) {
      qinput.value = '';
      qinput.focus();
      updateClearButton();
      ev.preventDefault();
    });
    qinput.addEventListener('input', updateClearButton, false);
  }

  const fetchResults = async (query) => {
    let request;
    if (coozila.settings.method === 'GET') {
      const reqParams = new URLSearchParams();
      reqParams.append("q", query);
      request = fetch("./autocompleter?" + reqParams.toString());
    } else {
      const formData = new FormData();
      formData.append("q", query);
      request = fetch("./autocompleter", {
        method: 'POST',
        body: formData,
      });
    }

    request.then(async function (response) {
      // CRITICAL FIX: Before showing results, check if the input is still valid.
      // This prevents a race condition where an old fetch re-opens the panel
      // after the user has already cleared the input.
      if (qinput.value.length < coozila.settings.autocomplete_min) {
        const autocomplete = d.querySelector(".autocomplete");
        if (autocomplete) {
          autocomplete.classList.remove('open');
        }
        return;
      }
      const results = await response.json();

      if (!results) return;

      const autocomplete = d.querySelector(".autocomplete");
      const autocompleteList = d.querySelector(".autocomplete ul");
      autocomplete.classList.add("open");
      autocompleteList.innerHTML = "";

      // show an error message that no result was found
      if (!results[1] || results[1].length == 0) {
        const noItemFoundMessage = document.createElement("li");
        noItemFoundMessage.classList.add('no-item-found');
        noItemFoundMessage.innerHTML = coozila.settings.translations.no_item_found;
        autocompleteList.appendChild(noItemFoundMessage);
        return;
      }

      for (let result of results[1]) {
        const li = document.createElement("li");
        li.innerText = result;

        coozila.on(li, 'mousedown', () => {
          qinput.value = result;
          const form = d.querySelector("#search");
          form.submit();
          autocomplete.classList.remove('open');
        });
        autocompleteList.appendChild(li);
      }
    });
  };

  coozila.ready(function () {
    // focus search input on large screens
    // if (!isMobile && !isResultsPage) document.getElementById("q").focus();
    // Find the search input element
    const searchInput = document.getElementById("q");

    // ONLY if the search input exists on this page, then try to focus it.
    if (searchInput && !isMobile && !isResultsPage) {
      searchInput.focus();
    }

    qinput = d.getElementById(qinput_id);
    const autocomplete = d.querySelector(".autocomplete");
    const autocompleteList = d.querySelector(".autocomplete ul");

    if (qinput !== null) {
      // clear button
      createClearButton(qinput);

      // autocompleter
      if (coozila.settings.autocomplete) {
        coozila.on(qinput, 'input', () => {
          const query = qinput.value;
          // If the query is too short (or empty), close the autocomplete panel and stop.
          if (query.length < coozila.settings.autocomplete_min) {
            const autocomplete = d.querySelector(".autocomplete");
            if (autocomplete) {
              autocomplete.classList.remove('open');
            }
            return;
          }

          setTimeout(() => {
            if (query == qinput.value) fetchResults(query);
          }, 300);
        });

        coozila.on(qinput, 'keyup', (e) => {
          let currentIndex = -1;
          const listItems = autocompleteList.children;
          for (let i = 0; i < listItems.length; i++) {
            if (listItems[i].classList.contains('active')) {
              currentIndex = i;
              break;
            }
          }

          let newCurrentIndex = -1;
          if (e.key === "ArrowUp") {
            if (currentIndex >= 0) listItems[currentIndex].classList.remove('active');
            // we need to add listItems.length to the index calculation here because the JavaScript modulos
            // operator doesn't work with negative numbers
            newCurrentIndex = (currentIndex - 1 + listItems.length) % listItems.length;
          } else if (e.key === "ArrowDown") {
            if (currentIndex >= 0) listItems[currentIndex].classList.remove('active');
            newCurrentIndex = (currentIndex + 1) % listItems.length;
          } else if (e.key === "Tab" || e.key === "Enter") {
            autocomplete.classList.remove('open');
          }

          if (newCurrentIndex != -1) {
            const selectedItem = listItems[newCurrentIndex];
            selectedItem.classList.add('active');

            if (!selectedItem.classList.contains('no-item-found')) qinput.value = selectedItem.innerText;
          }
        });
        coozila.on(qinput, 'focusout', (e) => {
          // 'relatedTarget' is the element that is receiving focus.
          // We close the panel ONLY if the focus is NOT moving to an element
          // within the autocomplete list itself. This allows suggestion clicks to work.
          if (!e.relatedTarget || !autocomplete.contains(e.relatedTarget)) {
            autocomplete.classList.remove('open');
          }
        });
      }
    }

    /**
     * -------------------------------------------------------------------------
     * Integrated & Dynamic Language Selector Logic (Final, Corrected & Universal)
     * -------------------------------------------------------------------------
     */
    const langTrigger = d.getElementById('language_trigger');
    const langOptionsContainer = d.querySelector('.language-options-list');

    if (langTrigger && langOptionsContainer) {
      const dataSourceSelect = langTrigger.querySelector('.language-data-source');
      const langOptionsList = langOptionsContainer.querySelector('ul');

      /**
       * Builds the custom language list (<ul>) from the hidden <select> options.
       * This ensures the list is always in sync with the form's data source.
       */
      const buildLanguageList = () => {
        langOptionsList.innerHTML = '';
        const options = Array.from(dataSourceSelect.options);
        const currentLangValue = dataSourceSelect.value;

        for (const option of options) {
          const li = d.createElement('li');
          li.className = 'language-option';
          li.dataset.value = option.value;
          
          if (option.value === currentLangValue) {
            li.classList.add('selected');
          }
          
          let iconHtml = '';
          const flag = option.dataset.flag;

          if (flag && flag.trim().length > 0) {
            // Differentiates between SVG icons and emoji flags
            if (flag.trim().startsWith('<svg')) {
              iconHtml = `<span class="language-option-icon">${flag}</span>`;
            } else {
              iconHtml = `<span class="language-option-icon"><span>${flag}</span></span>`;
            }
          }
          
          const nameHtml = `<span>${option.textContent.trim()}</span>`;
          
          li.innerHTML = iconHtml + nameHtml;
          
          // Use 'mousedown' for list items to ensure the form submits before the list closes.
          coozila.on(li, 'mousedown', function(e) {
            e.preventDefault();
            dataSourceSelect.value = this.dataset.value;
            d.getElementById('search').submit();
          });

          langOptionsList.appendChild(li);
        }
      };

      /**
       * Opens the language list and calculates its dynamic max-height.
       */
      const openLanguageList = () => {
        const autocomplete = d.querySelector('.autocomplete');
        if (autocomplete) {
          autocomplete.classList.remove('open');
        }
        buildLanguageList();
        langOptionsContainer.classList.add('open');

        // This is the only robust way to ensure the list fits the viewport.
        // --- START: Adaptive Max-Height Calculation ---
        const searchBox = d.querySelector('.search_box');
        if (searchBox) {
          const searchBoxRect = searchBox.getBoundingClientRect();
          const spaceBelow = window.innerHeight - searchBoxRect.bottom;
          let availableHeight;

          if (isMobile) {
            // On mobile, fill the entire available space below the search bar.
            const safetyMargin = parseFloat(getComputedStyle(d.documentElement).fontSize) * 0.8;
            availableHeight = spaceBelow - safetyMargin;
          } else {
            // On desktop, be aware of the footer.
            const footer = d.querySelector('footer');
            const footerHeight = footer ? footer.getBoundingClientRect().height : 0;
            /*
             * CRITICAL FIX: The safety margin now includes the required 1.6rem gap
             * PLUS the fixed 20px height of the dropdown's bottom shadow.
             */
            const safetyMargin = (parseFloat(getComputedStyle(d.documentElement).fontSize) * 0.8) + 20;            availableHeight = spaceBelow - footerHeight - safetyMargin;
          }
          
          langOptionsContainer.style.maxHeight = `${availableHeight}px`;
        }
        // --- FINISH: Adaptive Max-Height Calculation ---

        // Scroll the selected item into view.
        const selectedItem = langOptionsContainer.querySelector('.language-option.selected');
        if (selectedItem) {
          selectedItem.scrollIntoView({ block: 'nearest', inline: 'start' });
        }
      };

      /**
       * Closes the language list.
       */
      const closeLanguageList = () => {
        langOptionsContainer.classList.remove('open');
        // Reset max-height to allow CSS to take over on next open
        langOptionsContainer.style.maxHeight = '';
      };

      /**
       * A single, unified handler for the language trigger interaction.
       * It prevents default actions, forces the focus/layout change, and toggles the list.
       */
      const handleLanguageTrigger = (event) => {
        event.preventDefault();
        event.stopPropagation();

        const searchInput = d.getElementById('q');
        if (searchInput) {
          searchInput.focus();
        }

        if (langOptionsContainer.classList.contains('open')) {
          closeLanguageList();
        } else {
          openLanguageList();
        }
      };

      /**
       * Attach the correct event listener based on the device type.
       * - Mobile: Use 'touchstart' to fire early and avoid timing conflicts with focus/layout changes.
       * - Desktop: Use the standard 'click' event.
       */
      if (isMobile) {
        coozila.on(langTrigger, 'touchstart', handleLanguageTrigger);
      } else {
        coozila.on(langTrigger, 'click', handleLanguageTrigger);
      }

      /**
       * Closes the language list if the user starts typing in the search box.
       */
      const searchInput = d.getElementById('q');
      if (searchInput) {
        coozila.on(searchInput, 'input', closeLanguageList);
      }

      /**
       * Closes the language list if the user clicks anywhere outside of it.
       */
      coozila.on(w, 'click', (event) => {
        if (langOptionsContainer.classList.contains('open') && !langTrigger.contains(event.target)) {
          closeLanguageList();
        }
      });
    }
    // Language selector - finish

    // Additionally to searching when selecting a new category, we also
    // automatically start a new search request when the user changes a search
    // filter (safesearch, time range or language) (this requires JavaScript
    // though)
    if (
      qinput !== null
        && coozila.settings.search_on_category_select
      // If .search_filters is undefined (invisible) we are on the homepage and
      // hence don't have to set any listeners
        && d.querySelector(".search_filters") != null
    ) {
      coozila.on(d.getElementById('safesearch'), 'change', submitIfQuery);
      coozila.on(d.getElementById('time_range'), 'change', submitIfQuery);
      /// old selector removed coozila.on(d.getElementById('language'), 'change', submitIfQuery);
      // Hypatia suggests adding/modifying this code - start
      // CORRECTED: Add a listener to the *new* language data source
      const languageDataSource = d.querySelector('#language_trigger .language-data-source');
      if (languageDataSource) {
        coozila.on(languageDataSource, 'change', submitIfQuery);
      }
      // Hypatia suggests adding/modifying this code - finish
      
    }

    const categoryButtons = d.querySelectorAll("button.category_button");
    for (let button of categoryButtons) {
      coozila.on(button, 'click', (event) => {
        if (event.shiftKey) {
          event.preventDefault();
          button.classList.toggle("selected");
          return;
        }

        // manually deselect the old selection when a new category is selected
        const selectedCategories = d.querySelectorAll("button.category_button.selected");
        for (let categoryButton of selectedCategories) {
          categoryButton.classList.remove("selected");
        }
        button.classList.add("selected");
      });
    }

    // override form submit action to update the actually selected categories
    const form = d.querySelector("#search");
    if (form != null) {
      coozila.on(form, 'submit', (event) => {
        event.preventDefault();
        const categoryValuesInput = d.querySelector("#selected-categories");
        if (categoryValuesInput) {
          let categoryValues = [];
          for (let categoryButton of categoryButtons) {
            if (categoryButton.classList.contains("selected")) {
              categoryValues.push(categoryButton.name.replace("category_", ""));
            }
          }
          categoryValuesInput.value = categoryValues.join(",");
        }
        form.submit();
      });
    }
    // Filter Button Toggle Logic START
    const buttonFilters = d.getElementById('button_filters');
    const filtersDiv = d.querySelector(".search_filters");

    if (buttonFilters && filtersDiv) {
      coozila.on(buttonFilters, 'click', function () {
        if (filtersDiv.style.display === 'none') {
          filtersDiv.style.display = 'block';
          buttonFilters.classList.add('selected');
        } else {
          filtersDiv.style.display = 'none';
          buttonFilters.classList.remove('selected');
        }
      });

      coozila.on(buttonFilters, 'mousedown', function () {
        buttonFilters.classList.add('active');
      });

      coozila.on(buttonFilters, 'mouseup', function () {
        setTimeout(function () {
          buttonFilters.classList.remove('active');
        }, 50);
      });

      coozila.on(buttonFilters, 'mouseleave', function () {
        if (buttonFilters.classList.contains('active')) {
          buttonFilters.classList.remove('active');
        }
      });
    }
  });

})(window, document, window.coozila);
